import { isEmpty } from 'lodash'
import NotFoundComponent from '../../../../components/stories/molecules/not-found'
import { textStyleSizeOptions } from '../../../../components/stories/fundamentals/text-styles/constants'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { NotFoundContainerMobile } from '../../styled-component'
import { Plan } from '../../../../components/stories/atoms/icons/entities'
import colorsOptions from '../../../../components/stories/fundamentals/colors-styles/constants'

const PlanMenuMobileEmptyList = ({ search }) => {
  const { formatMessage } = useIntl()

  const icon = isEmpty(search) ? (
    <Plan
      style={{ width: '144px', height: '144px' }}
      stroke={colorsOptions.greys['grey-50']}
    />
  ) : null
  const header = isEmpty(search)
    ? 'plans_overview_empty-state_title'
    : 'no_result_found'
  const description = isEmpty(search)
    ? 'plans_overview_empty-state_description_restricted'
    : 'no_result_found_description'

  return (
    <NotFoundContainerMobile>
      <NotFoundComponent
        icon={icon}
        header={formatMessage({ id: header })}
        headerSize={textStyleSizeOptions['TEXT-XXL']}
        description={formatMessage({ id: description })}
        descriptionSize={textStyleSizeOptions['TEXT-L']}
      />
    </NotFoundContainerMobile>
  )
}

PlanMenuMobileEmptyList.propTypes = {
  search: PropTypes.string
}

export default PlanMenuMobileEmptyList
